import { createContext } from 'react';

const hamburgerContext = createContext({
    isOpen: false,
    setIsOpen: () => {}
});

export default hamburgerContext;
